module.exports = __webpack_public_path__ + "img/19307395000106.55c1e15a.png";